import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';

import { UiPalette } from '../../../types/UiPalette.type';

@Component({
  selector: 'eiq-dashboard-card',
  templateUrl: 'dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardCardComponent {
  title = input<string>();
  subtitle = input<string>();
  badgeText = input<string>();
  badgeColor = input<UiPalette>();
  badgeIcon = input<IconDefinition>();
  actionText = input<string>();
  testId = input<string>();

  open = output<void>();

  faArrowRight = faArrowRight;
}
